const request = require("request");

const getLocationByPincode = async (pincode) => {
    var options = {
        method: "GET",
        url: "https://api.postalpincode.in/pincode/" + pincode,
        headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
        },
        json: true
    }
    return new Promise((resolve, reject) => {
        request(options, function (error, response) {
            if (error) reject(error);
            resolve(response);
        });
    });
};
module.exports = {
    getLocationByPincode
}